export default __webpack_public_path__ + "static/media/mythicalbeings-transparent-800px.fab07df5.png";